import { render, staticRenderFns } from "./new-sale.vue?vue&type=template&id=634838ef&"
import script from "./new-sale.vue?vue&type=script&lang=js&"
export * from "./new-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports